"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var ui_components_1 = require("@l2p/ui-components");
var ui_components_2 = require("@l2p/ui-components");
var useSearchGamesDropdown_1 = __importDefault(require("./talons/useSearchGamesDropdown"));
var react_1 = __importStar(require("react"));
var apps_shared_1 = require("@l2p/apps-shared");
var SearchGamesDropdown = function (_a) {
    var games = _a.games, searchValue = _a.searchValue, gameCardPlaceholder = _a.gameCardPlaceholder;
    var _b = (0, useSearchGamesDropdown_1.default)({ games: games, searchValue: searchValue }), t = _b.t, breakpoints = _b.breakpoints, slicedGames = _b.slicedGames, handleLoadMoreButtonClick = _b.handleLoadMoreButtonClick;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.searchGameDropdown },
        !slicedGames.length ? (react_1.default.createElement("div", { className: styles_module_scss_1.default.searchWrapper },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.searchGameDropdownPlaceholder, dangerouslySetInnerHTML: {
                    __html: searchValue && searchValue.length >= 3
                        ? t.raw('searchBar.empty')
                        : t.raw('searchBar.start'),
                } }))) : (react_1.default.createElement("div", { className: styles_module_scss_1.default.gameItemWrapper }, slicedGames.map(function (game) {
            var _a;
            return (react_1.default.createElement(react_1.default.Fragment, null,
                !breakpoints.tablet && !breakpoints.mobile && (react_1.default.createElement(ui_components_1.DesktopGameCard, { withDemo: (_a = game === null || game === void 0 ? void 0 : game.settings) === null || _a === void 0 ? void 0 : _a['demo'], key: "search_bar_dropdown_".concat(game.id, "}"), title: game.title, gameId: game.id, slug: game.slug, gameCardPlaceholder: gameCardPlaceholder, signUpModalKey: apps_shared_1.POPUP_CONSTANTS.SIGN_UP_MODAL })),
                (breakpoints.tablet || breakpoints.mobile) && (react_1.default.createElement(ui_components_1.MobileGameCard, { key: "search_bar_dropdown_".concat(game.id, "}"), title: game.title, gameId: game.id, slug: game === null || game === void 0 ? void 0 : game.slug, gameCardPlaceholder: gameCardPlaceholder, gameInfoModalKey: apps_shared_1.POPUP_CONSTANTS.GAME_INFO_MODAL }))));
        }))),
        slicedGames.length && slicedGames.length < games.length ? (react_1.default.createElement("div", { className: styles_module_scss_1.default.dropdownFooter },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.loadMoreButtonWrapper },
                react_1.default.createElement(ui_components_2.LoadMoreButton, { onClick: handleLoadMoreButtonClick }, "Load more")))) : null));
};
exports.default = (0, react_1.memo)(SearchGamesDropdown);
